import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ErrorMessage,
    PayButton,
    PayButtonText,
    SuccessMessage,
} from 'src/components/TopUpProcedure/RealexForm/RealexTab.style';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { useAppStateContext } from 'src/AppState/AppState';
import { PaymentAdditionsNew } from 'src/components/CustomersBar/CustomerTab/BankingTab/components/PaymentsAdditionsNew';
//@ts-expect-error
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PaysafeTabState } from './PaysafeTabState';
import { PaysafePaymentProvider } from 'src/AppState/ConfigState/types';
import { PaysafeFrame } from './PaysafeFrame';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import { useCommon } from 'src/AppState/Common';

interface PropsType {
    customerId: number;
    permissionGrants: ImmutablePropTypes.map;
    paysafePaymentProviderConfig: PaysafePaymentProvider;
    onQueryAudits: () => void;
}
export const PaysafeTab = observer(
    'PaysafeTab',
    ({ customerId, permissionGrants, paysafePaymentProviderConfig, onQueryAudits }: PropsType): JSX.Element => {
        const { models } = useAppStateContext();

        const common = useCommon();

        const [stateAutoMap] = useState(
            () =>
                new AutoMap(
                    (customerId: number) =>
                        new PaysafeTabState(
                            models,
                            customerId,
                            permissionGrants,
                            paysafePaymentProviderConfig,
                            onQueryAudits,
                            common
                        )
                )
        );

        const state = stateAutoMap.get(customerId);

        return (
            <>
                <Input
                    dataTest='deposit-amount-input'
                    maxLength={10}
                    placeholder='0.00'
                    label='Amount'
                    formInputState={state.depositAmount}
                    onChange={state.onChange}
                />

                <PaymentAdditionsNew
                    value={state.depositAmount.value}
                    currency={state.getBalances.currency}
                    onChange={state.handleAdditionsChange}
                    handleActionOnInput={state.handleClear}
                />

                <ErrorMessage
                    isError={state.errorMessage !== null}
                    data-test='error-message'
                >
                    {state.errorMessage}
                </ErrorMessage>
                <SuccessMessage
                    isSuccess={state.successMessage === true}
                    data-test='success-message'
                >
                    Payment has been successfully processed
                </SuccessMessage>

                <table>
                    <tbody>
                        <tr data-test='deposit-form-current-balance'>
                            <th>Current balance:</th>
                            <td>{state.getBalances.balance}</td>
                        </tr>
                        <tr data-test='deposit-form-withdrawable-balance'>
                            <th>Withdrawable balance:</th>
                            <td>{state.getBalances.withdrawableBalance}</td>
                        </tr>
                        <tr data-test='deposit-form-new-balance'>
                            <th>New balance:</th>
                            <td>{state.getBalances.newBalance}</td>
                        </tr>
                    </tbody>
                </table>

                <PayButton
                    disabled={state.isEmptyAmountInput || state.getPermission}
                    onClick={state.submitDepositForm}
                    type='submit'
                >
                    <PayButtonText isDisabled={state.isEmptyAmountInput || state.getPermission}>Top Up</PayButtonText>
                </PayButton>
                {state.iframe.isOpen ? (
                    <PaysafeFrame
                        paymentIframeData={state.iframe.data}
                        paysafePaymentProvider={paysafePaymentProviderConfig}
                        paysafeTabState={state}
                    />
                ) : null}
            </>
        );
    }
);
